module.exports = __webpack_public_path__ + "static/colgadas-011.thumb-b759fd7e49580639954ca41d86bf6ead.jpg";